import { useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiProvider } from "./api/ApiContext";
import { TenantProvider } from "./tenant/TenantContext";
import { ApiError } from "./api/errors";
import type { PortalApi } from "./api/types";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Erros da API (401/403/422…) não devem ser re-tentados às cegas.
        retry: (failureCount, error) => !(error instanceof ApiError) && failureCount < 2,
        refetchOnWindowFocus: false,
      },
    },
  });
}

type Props = {
  children: ReactNode;
  // Injeção para testes.
  api?: PortalApi;
  queryClient?: QueryClient;
};

export function AppProviders({ children, api, queryClient }: Props) {
  const [client] = useState(() => queryClient ?? createQueryClient());
  return (
    <QueryClientProvider client={client}>
      <ApiProvider api={api}>
        <TenantProvider>{children}</TenantProvider>
      </ApiProvider>
    </QueryClientProvider>
  );
}
